function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { settingsActions } from '../../../reducers/settings.reducer';
import ModalHeader from '../../modal/ModalHeader.react';
import Button from '../../common/Button.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
var MetaDataAddRoute = function MetaDataAddRoute(_ref) {
  var selectedApp = _ref.selectedApp,
    _ref$selectedRoute = _ref.selectedRoute,
    selectedRoute = _ref$selectedRoute === void 0 ? null : _ref$selectedRoute,
    metaData = _ref.metaData,
    hideModalAction = _ref.hideModalAction,
    setMetaDataAction = _ref.setMetaDataAction;
  var _useState = useState({
      route: (selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.route) || '/',
      title: (selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.title) || ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];
  var route = form.route,
    title = form.title;
  var formatRoute = function formatRoute(route) {
    /*
    	TODO :: format and make sure it always starts with an /
    					not end with /
    					no more than one / in a row
    */
    route = route.trim().toLowerCase().replace(/[^a-z/]/g, '');
    if (route.length === 0) route = '/';
    setForm(_objectSpread(_objectSpread({}, form), {}, {
      route: route
    }));
  };
  var isValid = function isValid() {
    return route.length > 0 && route.charAt(0) === '/';
  };
  var isDuplicate = function isDuplicate() {
    if (selectedRoute) return false;
    if (metaData.filter(function (x) {
      return x.clientApp === selectedApp && x.route === route;
    })[0]) return 'This Route is already set up.';
    return false;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    title: "Add Route for ".concat(selectedApp.sValue)
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal__body"
  }, /*#__PURE__*/React.createElement(Label, {
    label: "Route",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: route,
    disabled: selectedRoute,
    onChange: function onChange(e) {
      return formatRoute(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title,
    onChange: function onChange(e) {
      return setForm(_objectSpread(_objectSpread({}, form), {}, {
        title: e.target.value
      }));
    }
  }), isDuplicate() && /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 20
    }
  }, isDuplicate()), /*#__PURE__*/React.createElement(Button, {
    label: "Add",
    disabled: !isValid() && !isDuplicate(),
    onClick: function onClick() {
      setMetaDataAction({
        id: (selectedRoute === null || selectedRoute === void 0 ? void 0 : selectedRoute.id) || null,
        clientApp: selectedApp,
        route: route,
        title: title
      });
      hideModalAction();
    }
  })));
};
var mstp = function mstp(s) {
  return {
    metaDataConstants: s.settings.constants.metaData
  };
};
var mdtp = {
  hideModalAction: modalActions.hide,
  setMetaDataAction: settingsActions.setMetaData
};
export default connect(mstp, mdtp)(MetaDataAddRoute);